import { BASE_URL_API } from 'constants/base-url-default'
import { getCookie } from 'utils/functions-cookie'

export type User = {
  id: string
  name: string
  email: string
}

export const fetchUsers = async () => {
  const authToken = getCookie('auth_token')

  if (!authToken) {
    throw new Error('Você não está autenticado.')
  }

  const response = await fetch(`${BASE_URL_API}/users`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${authToken}`,
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json',
    },
  })

  if (!response.ok) {
    if (response.status === 403) {
      throw new Error('Sessão expirada')
    }
    throw new Error('Erro ao buscar usuários.')
  }

  return (await response.json()) as User[]
}
